import { useLocation } from "react-router-dom";

export default function useLocationState<T>(key: string): T | undefined {
    const location = useLocation();
    return location.state ? location.state[key] : undefined;
}
